module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-philosophy-7210081efd22eaf58835df081e533877.jpg";